//import 'ol/ol.css';
import { WKT } from 'ol/format';
import { getLength } from 'ol/sphere';
import * as toastr from "toastr";
import { INode, FeatureType, IFeatureTypeOptions, ICAMSKey, IFeaturesRequest, IMapInteractionConfig, IAPIResult, CloseFormEnum, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import * as AuthModel from '../Models/AuthModel';
import * as events from '../Bus/Bus';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter, ActivityCreateModel } from '../Activity/Activity';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { CAMSMap } from '../../Extensions/CAMSOLExtensions';
import { Entity_RouteCondition, routeConditionCreateCallback } from './Entity_RouteCondition';
import { Entity_RouteContact } from './Entity_RouteContact';
import { Entity_RouteAltRouteCodes } from './Entity_RouteAltRouteCodes';
import { Entity_RouteChangeRouteCodes } from './Entity_RouteChangeRouteCodes';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';
import { Callbacks } from 'jquery';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_RouteView {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private Entity_RouteContact = new Entity_RouteContact();
    private Entity_RouteAltRouteCodes = new Entity_RouteAltRouteCodes();
    private photos: Photos = new Photos();
    private routeCondition: Entity_RouteCondition = new Entity_RouteCondition();
    private Entity_RouteChangeRouteCodes = new Entity_RouteChangeRouteCodes();

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected map: CAMSMap, protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openEditPanel = (data: ICAMSKey): void => {
        const self = this;
       
        // Check to see if the user has permissions, if not pop a toast
        if (self.authModel.policies.find(p => p == AuthModel.CAMSMap_CanEditRoute) != null) {
            self.internalOpenEditPanel(data);
        }
        else {
            self.internalOpenViewPanel(data);
        }
    }

    // ----------------------------------------------------------- //
    // PRIVATE Functions
    private internalOpenViewPanel = (data: ICAMSKey): void => {
        const self = this;

        // Open the edit modal
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME +'/Route/RouteView', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.UnBlockUI();

            // Show the form
            Utilities.GetModal('#routeViewModal', ModalAction.Create);
            
            // Create Tables
            ($('#routeViewConditionTable') as any).bootstrapTable();
            ($('#routeViewLandTable') as any).bootstrapTable();
            ($('#routeViewFurnitureTable') as any).bootstrapTable();
            ($('#routeViewIssuesTable') as any).bootstrapTable();
            ($('#routeViewTasksTable') as any).bootstrapTable();
            ($('#routeViewAltCodesTable') as any).bootstrapTable();
            ($('#routeViewContactsTable') as any).bootstrapTable();
            
            //initialise photo uploader
            self.photos.setupUploader('#routeViewModal');

            // Get UDF's and conditional fields
            $('#Status').on('change', function () {
                UserDefinedFields.ShowHideUDFs(<string>$('#Status').children("option:selected").val(), $("#routeViewForm"));
            });
            UserDefinedFields.ShowHideUDFs(<string>$('#Status').children("option:selected").val(), $("#routeViewForm"));

            // Get form validation
            Utilities.InitFormValidation($("#routeViewForm"));

            //calculate length from geometry
            try {
                let format = new WKT();
                var feature = format.readFeature(data.wkt, {
                    dataProjection: 'EPSG:27700',
                    featureProjection: 'EPSG:3857'
                });
                data.metadata.featureLength = parseFloat(getLength(feature.getGeometry()).toFixed(2));
                $('#Length').val(data.metadata.featureLength.toString());
            }
            catch (e) {
                console.log("ERROR Calculating length! ", e);
            }

            $('#routeViewCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeViewModal', ModalAction.Hide);
            });

            events.bus.publish(events.eventGetActivities([data, true, function (d) {
                var table = ($('#routeViewActivityTable') as any);
                table.bootstrapTable();
                table.bootstrapTable('load', d);
            }]));
        });
    }

    private internalOpenEditPanel = (data: ICAMSKey): void => {
        const self = this;

        // Check to see if the user has permissions, if not pop a toast
        if (self.authModel.policies.find(p => p == AuthModel.CAMSMap_CanEditRoute) == null) {
            toastr.error("You do not have rights to edit this type of record.");
            return;
        }

        // Open the edit modal
        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME + '/Route/RouteEdit', { routeCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.UnBlockUI();

            // Show the form
            Utilities.GetModal('#routeEditModal', ModalAction.Create);

            // Create Tables
            ($('#routeEditConditionTable') as any).bootstrapTable();
            ($('#routeEditLandTable') as any).bootstrapTable();
            ($('#routeEditFurnitureTable') as any).bootstrapTable();
            ($('#routeEditIssuesTable') as any).bootstrapTable();
            ($('#routeEditTasksTable') as any).bootstrapTable();
            ($('#routeEditAltCodesTable') as any).bootstrapTable();
            ($('#pathEditLegalTable') as any).bootstrapTable();
            ($('#routeEditContactsTable') as any).bootstrapTable();

            // Get extra table data
            self.GetPathLegal(data);
            if ($('#routeEditHistoricTable')[0]) ($('#routeEditHistoricTable') as any).bootstrapTable();

            // Add entity click events
            $('#routeEditModal [data-routeparentref]').on('click', function () {
                const pathData: ICAMSKey = $(this).data("routeparentref");
                events.bus.publish(events.eventOpenPathEditPanel(pathData));
                Utilities.GetModal('#routeEditModal', ModalAction.Hide);
            });

            $('#routeEditConditionTable [data-routeconditionref]').on('click', function () {               
            });
            // ******************************************************************************
            // Route Edit Condition Table click Events
            var table: any = Utilities.GetControl('#routeEditConditionTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "id") {                    
                    var conditionData: ICAMSKey = $element.find("[data-routeconditionref]").data("routeconditionref");
                    self.routeCondition.openConditionEditPanel(conditionData, function () {
                        self.openEditPanel(data);
                    });
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Route Edit Contact Table click Events
            var table: any = Utilities.GetControl('#routeEditContactsTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "name") {                    
                    var ID: number = $element.data("contactid");
                    if (originalFormData !== $('#routeEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openContact();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openContact();
                            });
                        });
                    }
                    else openContact();                    
                }
                function openContact() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    self.Entity_RouteContact.openRouteContactEditPanel(ID, function () {
                        self.openEditPanel(data);
                    });
                }
            });
            // ******************************************************************************
            // Route Edit Land Table click Events
            var table: any = Utilities.GetControl('#routeEditLandTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "code") {
                }
            });
            // ******************************************************************************
            // Route Edit Furniture Table click Events
            var table: any = Utilities.GetControl('#routeEditFurnitureTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "code") {                  
                    var fdata: ICAMSKey = $element.find("[data-infraref]").data("infraref");                    
                    if (originalFormData !== $('#routeEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openForm();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openForm();
                            });
                        });
                    }
                    else openForm();
                }             
                function openForm() {
                    events.bus.publish(events.eventOpenInfraEditPanel([fdata, function (result) {
                        self.openEditPanel(data);
                    }]));
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Route Edit Furniture Historic Table click Events
            var table: any = Utilities.GetControl('#routeEditHistoricTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "infracode") {                   
                    var uid = $element.data("historicid");
                    if (originalFormData !== $('#routeEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openForm(uid);
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openForm(uid);
                            });
                        });
                    }
                    else openForm(uid);
                }
                function openForm(ic: ICAMSKey) {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenInfraHistoricDetailsPanel([{ code: uid, featureType: FeatureType.InfraHistoric }, function (result) {
                        self.openEditPanel(data);
                    }]));
                }
                
            });
            // ******************************************************************************
            // Route Edit Issue Table click Events
            var table: any = Utilities.GetControl('#routeEditIssuesTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "code") {                    
                    var cdata: ICAMSKey = $element.find("[data-issueref]").data("issueref");
                    if (originalFormData !== $('#routeEditForm').serialize()) {
                        Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                            if (r == CloseFormEnum.DisregardAndProceed) openForm();
                            else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                if (s == true) openForm();
                            });
                        });
                    }
                    else openForm();                    
                }
                function openForm() {
                    events.bus.publish(events.eventOpenMaintEditPanel(cdata));
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Route Edit Task Table click Events
            var table: any = Utilities.GetControl('#routeEditTasksTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "taskType") {                   
                    var taskID = $element.data("taskid");
                    var camsKey: ICAMSKey = { code: taskID, featureType: FeatureType.Task };
                    events.bus.publish(events.eventOpenTasksEditPanel([camsKey, function (r) {
                        events.bus.publish(events.eventOpenRouteEditPanel(data));
                        Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    }]))
                }
            });
            $('#routeEditNewContactBtn').on('click', function () {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openNewContact();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) {
                                openNewContact();
                            }
                        });
                    });
                }
                else openNewContact();

                function openNewContact() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    self.Entity_RouteContact.openRouteContactCreatePanel(data, function () {
                        self.openEditPanel(data);
                    });
                }
            });

            $('#routeEditModal [data-contactid]').on('click', function () {           
            });

            $('#routeEditFurnitureTable [data-infraref]').on('click', function () {               
            });

            $('#routeEditIssuesTable [data-issueref]').on('click', function () {             
            });

            // ACTIVITY
            getActivities(true); // Get activities when the form first loads
            $('#routeEditModal [name="showAllActivities"]').on('change', function () {
                var checked = $(this).prop('checked');
                getActivities(!checked);
            });

            function getActivities(excludeAuditActivities: Boolean) {
                events.bus.publish(events.eventGetActivities([data, excludeAuditActivities, function (d) {
                    var table = ($('#routeEditActivityTable') as any);
                    table.bootstrapTable();
                    table.bootstrapTable('load', d);

                    // Add entity cklick events
                    table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                        if (field == "uid") {                           
                            var ID: number = $element.find("[data-activityid]").data("activityid");
                            if (originalFormData !== $('#routeEditForm').serialize()) {
                                Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                                    if (r == CloseFormEnum.DisregardAndProceed) openContact();
                                    else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                                        if (s == true) openContact();
                                    });
                                });
                            }
                            else openContact();
                        }
                            function openContact() {
                                Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                                events.bus.publish(events.eventOpenActivityDetailsPanel([ID, function (r) {
                                    if (r == true) {
                                        events.bus.publish(events.eventOpenRouteEditPanel(data)); // This re-opens the edit form which refreshes the Maint form
                                    }
                                    else {
                                        Utilities.GetModal('#routeEditModal', ModalAction.Show);
                                    }
                                }]));
                            }
                        
                    });
                }]));
            }

            $('#routeEditNewActivityBtn').on('click', function () {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    var activityData: ActivityCreateModel = { ID: data.code, activityListType: ActivityListType.RouteActivity };
                    events.bus.publish(events.eventOpenActivityCreatePanel([activityData, function (r) {
                        if (r == true) {
                            events.bus.publish(events.eventOpenRouteEditPanel(data)); // This re-opens the edit form which refreshes the Route form
                        }
                        else {
                            Utilities.GetModal('#routeEditModal', ModalAction.Show);
                        }
                    }]));
                }
            });

            // INFRA HISTORIC
            $('#routeEditModal [data-historicid]').on('click', function () {             
            });

            // RouteAltCodes
            $('#routeEditNewAltCodeBtn').on('click', function () {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    self.Entity_RouteAltRouteCodes.openRouteAltRouteCodesCreatePanel(data.code, function (r) {
                        events.bus.publish(events.eventOpenRouteEditPanel(data)); // This re-opens the edit form which refreshes the Route form
                    });
                }
            });

            // RouteChangeCode
            $('#routeEditChangeCodeBtn').on('click', function () {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) openForm();
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    self.Entity_RouteChangeRouteCodes.openRouteChangeRouteCodePanel(data.code, function (r) {
                        if (r !=null) {
                            events.bus.publish(events.eventRefreshMapLayer(null));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            events.bus.publish(events.eventMapClosePopup());
                   
                            var newData = data; newData.code = r;
                            events.bus.publish(events.eventOpenRouteEditPanel(newData)); // This re-opens the edit form which refreshes the Route form
                        }
                    });
                }
            });

            // Table
            var table: any = ($('#routeEditAltCodesTable') as any).bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "Delete") {
                    self.Entity_RouteAltRouteCodes.deleteEntity(data, row.routeAltCodeType, row.code, function (r) {
                        if (r == true) {
                            Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                            events.bus.publish(events.eventOpenRouteEditPanel(data));
                        }
                    });
                }
            });

            //initialise photo uploader
            self.photos.setupUploader('#routeEditModal');

            // Get UDF's and conditional fields
            $('#Status').on('change', function () {
                UserDefinedFields.ShowHideUDFs(<string>$('#Status').children("option:selected").val(), $("#routeEditForm"));
            });
            UserDefinedFields.ShowHideUDFs(<string>$('#Status').children("option:selected").val(), $("#routeEditForm"));

            // Get form validation
            Utilities.InitFormValidation($("#routeEditForm"));

            //calculate length from geometry
            try {
                let format = new WKT();
                var feature = format.readFeature(data.wkt, {
                    dataProjection: 'EPSG:27700',
                    featureProjection: 'EPSG:3857'
                });
                data.metadata.featureLength = parseFloat(getLength(feature.getGeometry()).toFixed(2));
                $('#Length').val(data.metadata.featureLength.toString());
            }
            catch (e) {
                console.log("ERROR Calculating length! ", e);
            }

            
            function doSubmit() {
                return new Promise<boolean>(function (resolve, reject) {

                    // Validate
                    let form: any = $('#routeEditForm');
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($("#routeEditModal .modal-content"));
                    let formData = new FormData(<any>$('#routeEditForm')[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Route/UpdateRoute',
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                    UserDefinedFields.SaveUDFFieldsAtServer($('#routeEditForm'), '/Route/UpdateRouteUserFields');
                                    events.bus.publish(events.eventRefreshMapLayer(FeatureType.Route));
                                    events.bus.publish(events.eventEntityUpdated(data));
                                    resolve(true);
                                }
                                else {
                                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });

                                    resolve(false);
                                }
                            }
                            catch (err) {
                                console.log(err);
                                resolve(false);
                            }
                            finally {
                                Utilities.UnBlockUI($("#routeEditModal .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                        resolve(false);
                    });
                });
            };

            // Bind buttons
            $('#routeEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                doSubmit().then(s => { if (s == true) Utilities.GetModal('#routeEditModal', ModalAction.Hide); });
            });

            $('#routeEditNewConditionBtn').on('click', function () {
                Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                self.routeCondition.openConditionCreatePanel(data, function () {
                    self.openEditPanel(data);
                });
            });
            $('#routeEditNewFurnitureBtn').on('click', function () { self.createNewInfraOnRoute(data); });
            $('#routeEditNewIssueBtn').on('click', function () { self.createNewIssuesOnRoute(data); });

            $('#routeEditCancelBtn').on('click', function (evt) {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    });
                }
                else Utilities.GetModal('#routeEditModal', ModalAction.Hide);
            });

            $('#routeEditModal [data-taskid]').on('click', function () {              
            });
            $('#routeEditNewTaskBtn').on('click', function () {
                if (originalFormData !== $('#routeEditForm').serialize()) {
                    Utilities.CloseFormWithSaveFirstPrompt().then(r => {
                        if (r == CloseFormEnum.DisregardAndProceed) openForm();
                        else if (r == CloseFormEnum.SaveAndProceed) doSubmit().then(s => {
                            if (s == true) {
                                Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                                openForm();
                            }
                        });
                    });
                }
                else openForm();

                function openForm() {
                    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenTasksCreatePanel([[data], function (r) {
                        events.bus.publish(events.eventOpenRouteEditPanel(data)); // This re-opens the edit form which refreshes the route form
                        //if (r == true) {
                        //    events.bus.publish(events.eventOpenRouteEditPanel(data)); // This re-opens the edit form which refreshes the route form
                        //}
                        //else {
                        //    Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                        //}
                    }]));
                }
            });

            $('#routeEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(data);
            });

            // Save the original state of the edit form
            var originalFormData = $('#routeEditForm').serialize();

        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (data: ICAMSKey): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Route/DeleteRoute', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.Route));
                            events.bus.publish(events.eventClearAllHighlights());
                            events.bus.publish(events.eventRemoveAllMapInteractions());
                            events.bus.publish(events.eventResetAllButtons(true));
                            Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // CREATE new linked records
    private createNewInfraOnRoute = (data: ICAMSKey): void => {
        Utilities.GetModal('#editModal', ModalAction.Create);
        events.bus.publish(events.eventNewInfraWizardStart([data, null, null]));
    }

    private createNewIssuesOnRoute = (data: ICAMSKey): void => {
        Utilities.GetModal('#editModal', ModalAction.Create);
        events.bus.publish(events.eventNewMaintWizardStart([data, null, null]));
    }

    private GetPathLegal = (data: ICAMSKey): void => {
        const self = this;

        let url = "/Legal/GetLegalByRouteCode";
        Utilities.BlockUI($('#routeEditLegalTable'));
        $.post(url, { routeCode: data.code },
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#routeEditLegalTable'));
                try {
                    if (result.success == true) {
                        var table = ($('#routeEditLegalTable') as any);
                        table.bootstrapTable();
                        table.bootstrapTable('load', result.data);

                        // Add entity cklick events
                        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                            if (field == 'legalCode') {                                
                                var ldata: ICAMSKey = $element.find("[data-legalref]").data("legalref");
                                events.bus.publish(events.eventOpenLegalEventsEditPanel(ldata));
                                Utilities.GetModal('#routeEditModal', ModalAction.Hide);
                            }
                        });
                        $('#routeEditLegalTable [data-legalref]').on('click', function () {                           
                        });
                    }
                    else {
                        toastr.error('Failed to get legal data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME + '/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




